<template>
	<div>
		<user-nav-menu bg-color="transparent" text-color="#ffffff" :disable-edit-profile="true" :logo-file-name="tenant.settings.brandImages.headerLogos.app.light"></user-nav-menu>
		<v-row align="center" justify="center">
			<v-col cols="11" md="7" sm="7">
				<v-overlay :value="spinning"><v-progress-circular :indeterminate="true"></v-progress-circular></v-overlay>
				<h1 class="create-profile-title justify-center text-center pb-1 pt-5">Edit Profile</h1>

				<notification v-show="showNotification"></notification>

				<v-card class="card-rounded elevation-1 mt-3 pt-3" style="width: 100%; height: auto">
					<v-btn
						v-show="context != 'complete-profile-steps' && context != previous_context && previous_context != null"
						class="mt-5"
						fab
						absolute
						left
						top
						text
						x-large
						color="secondary"
						style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 18px; line-height: 17px"
						@click="goBack"
						><v-icon x-large color="secondary">mdi-chevron-left</v-icon>Back</v-btn
					>

					<v-container v-show="context === 'complete-profile-steps'" align="center" justify="center" class="pa-5 pb-0">
						<v-list-item three-line>
							<v-list-item-content>
								<v-list-item-title class="text-center text-wrap">Edit or add to your profile by choosing a section below</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-container>

					<component :is="context ? context : 'v-card'" :required_forms="required_forms" :booster_forms="[]" :button-colours="buttonColours"></component>

					<v-card-actions align="center" justify="center" class="justify-center text-center">
						<v-container class="justify-center text-center">
							<v-row align="center" justify="center">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										v-show="show_button"
										:loading="spinning"
										large
										class="button-rounded continue-signup-button text-none"
										:height="54"
										color="primary"
										@click="SubmitForm()"
										>Save changes<v-icon>mdi-chevron-right</v-icon></v-btn
									>
								</v-col>
							</v-row>
							<v-row v-show="context != 'complete-profile-steps'">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: normal;
											font-size: 14px;
											line-height: 18px;
											text-align: right;
											text-decoration-line: none;
										"
										@click="returnToOverview"
									>
										Return to Profile Overview
									</v-btn>
								</v-col>
							</v-row>
							<!-- <v-row v-show="context != 'complete-profile-steps'" class="justify-center text-center">
								<v-col cols="12" class="justify-center text-center">
									<v-list-item-title
										class="pt-0 mt-0 justify-center text-center"
										text
										link
										style="
											color: primary;
											font-family: Montserrat;
											font-style: normal;
											font-weight: normal;
											font-size: 11px;
											line-height: 17px;
											text-align: right;
											text-decoration-line: underline;
										"
									>
										Should your practice manager details require a change please email us at hello@locumbase.com.
									</v-list-item-title>
								</v-col>
							</v-row> -->
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-btn
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: right;
											text-decoration-line: none;
										"
										@click="returnToDashboard"
									>
										Return to Dashboard
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { bus } from '@/main';
import { VImg } from 'vuetify/lib';
// import { Auth } from 'aws-amplify'
// import axios from 'axios';
import store from '@/store';

import PracticeSwitchCard from '@/components/ui/dashboard/practice/cards/PracticeSwitchCard';
// import UserDashboardAvatar from '@/components/user/UserDashboardAvatar';

import CompleteProfileSteps from '@/components/practice/profile/EditProfileStepsForm.vue';
import notification from '@/components/locum/complete profile steps/notification.vue';

import addressStep from '@/components/practice/complete profile steps/Address.vue';
import operationsStep from '@/components/practice/complete profile steps/Operations.vue';
import aboutStep from '@/components/practice/complete profile steps/About.vue';
import UserNavMenu from '@/components/user/UserNavMenu';

import { Tracking } from '@/utils';

export default {
	name: 'PracticEditProfile',
	components: {
		VImg,
		PracticeSwitchCard,

		CompleteProfileSteps,
		notification,
		UserNavMenu,

		addressStep,
		operationsStep,
		aboutStep,

		// UserDashboardAvatar,
	},
	data: () => ({
		topcard: 'progressbar',
		showNotification: false,
		// button_text : "None",
		// button_color : "primary",
		button_state: false,
		spinning: false,
		button_loading: false,
		add_user_img: require('@/assets/images/person_add_alt_1-24px.svg'),
		managed_users_img: require('@/assets/images/people_alt-24px.svg'),
		existing_user_img: require('@/assets/images/person_search-24px.svg'),
		user_management_context: false,
		focused_manager: null,
		selected_role: null,
		email_to_invite: null,
		previous_context: null,
		buttonColours: [],
	}),
	computed: {
		company: () => store.getters.company,
		required_forms: () => store.getters.stepsRequiredCompany,
		context: () => store.getters.currentStepCompany,
		next_step: () => store.getters.getNextSignupStepCompany,
		show_button: function () {
			return this.context != 'complete-profile-steps';
		},
	},

	async mounted() {
		Tracking.track('Practice_Edit_Profile', {});
		bus.$on('intent:previous-context', () => {
			store.commit('SET_STEP_COMPANY', this.previous_context);
			bus.$emit('steps@refresh');
		});
		bus.$on('intent:change-context', new_context => {
			this.previous_context = this.context;
			store.commit('SET_STEP_COMPANY', new_context); //get the state and commit.
			// if(new_context == 'complete-profile-steps'){
			bus.$emit('steps@refresh');
			// }
		});
		bus.$on('intent:next-step', () => {
			bus.$emit('intent:change-context', 'complete-profile-steps');
			bus.$emit('push:notification@update', {
				title: 'Profile Updated',
				subtitle: 'Your profile was updated successfully.',
				avatar: false,
				//disabled action as per garretts request ->
				// actions : [
				//   {text : "force approve locum", onclick : ()=>{
				//     store.dispatch("ApproveProfessional");
				//     bus.$emit("steps@refresh"); //refresh the steps to update the state.
				//   }}
				// ]
			});
			bus.$emit('push:notification@show');
		});

		bus.$on('push:notification@hide', () => {
			this.showNotification = false;
		});

		bus.$on('push:notification@show', () => {
			this.showNotification = true;
		});

		bus.$on('update:spinning', value => {
			this.spinning = value;
		});
	},

	created() {
		this.buttonColours = store.getters.getProfileButtonColours;
	},
	beforeDestroy() {
		bus.$off('intent:previous-context');
		bus.$off('intent:change-context');

		bus.$off('update:spinning');

		bus.$off('update:topcard');

		bus.$off('push:notification@hide');

		bus.$off('push:notification@show');

		bus.$off('steps@refresh');

		bus.$off('intent:next-step');

		bus.$off('update:next-button-text');

		bus.$off('update:next-button-color');

		bus.$off('update:next-button-enable');
	},

	methods: {
		goBack() {
			bus.$emit('intent:previous-context');
		},
		returnToDashboard() {
			bus.$emit('intent:change-context', 'complete-profile-steps');
			this.$router.push('/').catch(() => {});
		},
		returnToOverview() {
			bus.$emit('intent:change-context', 'complete-profile-steps');
		},
		SubmitForm() {
			bus.$emit('intent:submit-forms' + ':' + this.context); //submit the form, the form is expected to fire the 'next-step' intent when done.
		},
	},
};
</script>
